import React, { useMemo, useCallback } from "react";
import { Button, Modal, Row, Col, message, Alert } from "antd";
import { connect } from "dva";
import moment from "moment";
import { LoadStatus } from "@/utils/enum";

const { confirm } = Modal;

const LotExitAlert = ({ dispatch, adminShipmentView, configPerm }) => {
  const adminShipmentData = useMemo(() => adminShipmentView?.data, [adminShipmentView]);

  const handleClickedConfirmLotExit = useCallback(async () => {
    const shipmentId = adminShipmentData?.id;
    const loadId = adminShipmentData?.load?.id;

    if (!shipmentId || !loadId) return;

    confirm({
      title: "Confirm Lot Exit",
      content: "Are you sure you want to confirm lot exit for the vehicles in this shipment?",
      onOk() {
        const hide = message.loading("Confirming...", 0);
        dispatch({
          type: "adminShipmentView/confirmLotExit",
          shipmentId,
          loadId,
        }).then(result => {
          hide();

          if (result?.error) {
            message.error("Error confirming lot exit");
            return;
          }

          message.success("Successfully confirmed lot exit.");
        });
      },
    });
  }, [dispatch, adminShipmentData]);

  if (!adminShipmentData.requiresLotExit) {
    return null;
  }

  return (
    <Row
      style={{
        width: "100%",
      }}
      gutter={[20]}
    >
      <Col span={24}>
        {adminShipmentData?.lotExit?.pendingCount === 0 && adminShipmentData?.load?.status >= LoadStatus.PickedUp ? (
          <Alert
            message={<strong>Lot Exit Confirmed</strong>}
            banner
            type="success"
            showIcon
            style={{
              width: "100%",
              marginLeft: 20,
              marginBottom: 16,
            }}
            action={
              <span>
                {adminShipmentData?.lotExit?.lastCompletedAt
                  ? moment
                      .utc(adminShipmentData?.lotExit?.lastCompletedAt)
                      .locale("en")
                      .local()
                      .format("MM/DD/YYYY, h:mm A")
                  : "N/A"}
              </span>
            }
          />
        ) : (
          <Alert
            message={<strong>Lot Exit Required</strong>}
            banner
            type="warning"
            showIcon
            style={{
              width: "100%",
              marginLeft: 20,
              marginBottom: 16,
            }}
            action={
              configPerm["CoreService.AdminShipments.LotExitComplete"] &&
              adminShipmentData?.load?.status === LoadStatus.PickedUp && (
                <Button type="primary" onClick={handleClickedConfirmLotExit}>
                  Confirm Lot Exit
                </Button>
              )
            }
          />
        )}
      </Col>
    </Row>
  );
};

export default connect(({ adminShipmentView, configs }) => ({
  adminShipmentView,
  configPerm: configs.configPerm,
}))(LotExitAlert);
